import React from 'react';
import StudentRow from './StudentRow';
import { ROSTER_WORDING as W } from '../../domain/roster';
import s from './students.module.css';

// The students table. Horizontal scroll lives on the wrapper so turning on a
// dozen optional columns widens the table instead of the page.

export default function StudentTable({
  rows, columns, selected, allSelected, onSelectAll, onTick, onOpen, cellContext,
}) {
  return (
    <div className={s.tableWrap}>
      <table className={s.table}>
        <thead>
          <tr>
            <th className={s.tickCell}>
              <input
                type="checkbox"
                checked={allSelected}
                aria-label={W.selectAll}
                onChange={(e) => onSelectAll(e.target.checked)}
              />
            </th>
            {columns.map((c) => <th key={c.id}>{c.label}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.map((student) => (
            <StudentRow
              key={student.id}
              student={student}
              columns={columns}
              ticked={selected.has(student.id)}
              onTick={onTick}
              onOpen={onOpen}
              cellContext={cellContext}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
